import * as React from "react";
import {LoadingViewState, RouterView} from "../RouterView";
import {formatDate} from "../../util/date";
import {RouteComponentProps, withRouter} from "react-router";
import {WalletService} from "../../services/WalletService";
import {getContainer} from "../../ioc/IOCSetup";
import {TransactionEntriesService} from "../../services/TransactionEntriesService";
import {Account, AccountBalanceResult, AccountStatus} from "../../http/protocol";
import {AccountActions} from "./AccountActions";
import {UserLinkPanel} from "../user/UserLinkPanel";
import {AttributePanel} from "../AttributePanel";
import {TransactionEntriesList} from "./TransactionEntriesList";


interface State extends LoadingViewState{
    balance? : AccountBalanceResult;
    account? : Account;
}

export class AccountView extends RouterView<RouteComponentProps,State>{

    walletService : WalletService;
    transactionEntriesService : TransactionEntriesService;

    constructor(props : RouteComponentProps){
        super(props);
        this.walletService = getContainer().getWalletService();
        this.transactionEntriesService = getContainer().getTransactionEntriesService();
        this.state = { };
    }

    getTitle() {
        return "Account";
    }

    loadContent(): Promise<any>  {
        var id = (this.props.match.params as any).id;
        return Promise.all<any>([
            this.walletService.getAccountBalance(id),
            this.walletService.getAccount(id)

        ]).then((results) => {
            let balance : AccountBalanceResult = results[0];
            let account : Account = results[1];
            this.setState({ balance : balance, account : account});
        })
    }


    getDateTime(timestamp?:Date|number) {
        if (typeof(timestamp) == "undefined" || timestamp < 2) {
            return "";
        }
        return formatDate(timestamp);
    }

    getAccountStatusBadge() {

        if (this.state.account && this.state.account.status === AccountStatus.OPEN) {
            return (<span className="badge badge-success float-right">Open</span>);
        } else {
            return (<span className="badge badge-danger float-right">Closed</span>);
        }
    }

    renderContent() {
        const amount = this.state.balance && this.state.balance.balance && this.state.balance.balance.amount && this.state.balance.balance.amount.toLocaleString("en",{maximumFractionDigits:8, minimumFractionDigits:2});
        if (!this.state.balance || !this.state.balance.balance || !this.state.account || !this.state.account.attributes) {
            return <div></div>;
        }
        return (
            <div>

                    <div className="row">
                        <div className="col-lg-6">
                            <div className="card-box">
                                <div className="ibox-content">
                                    <div className="row">
                                        <div className="col-lg-12">
                                            <div className="m-b-md">
                                                <dd className="pull-right">{this.getAccountStatusBadge()}</dd>
                                                <h4>Account Details</h4>
                                                <small className="text-success">{this.state.account.attributes["gameName"]}</small>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-lg-12">
                                            <table className="table table-striped">
                                                <tbody>
                                                <tr>
                                                    <td style={{ width : "30%"}}>Account ID:</td>
                                                    <td>{this.state.balance.accountId}</td>
                                                </tr>
                                                <tr>
                                                    <td>Status:</td>
                                                    <td>{this.state.account.status}</td>
                                                </tr>
                                                <tr>
                                                    <td>Balance:</td>
                                                    <td>{amount}</td>
                                                </tr>

                                                <tr>
                                                    <td>Currency:</td>
                                                    <td>{this.state.account.currencyCode}</td>
                                                </tr>
                                                <tr>
                                                    <td>Role:</td>
                                                    <td>{this.state.account.attributes["ROLE"]}</td>
                                                </tr>
                                                <tr>
                                                    <td>User ID:</td>
                                                    <td>{this.state.account.userId}</td>
                                                </tr>
                                                <tr>
                                                    <td>Operator ID:</td>
                                                    <td>{this.state.account.operatorId}</td>
                                                </tr>
                                                <tr>
                                                    <td>Account Type:</td>
                                                    <td>{this.state.account.type}</td>
                                                </tr>
                                                <tr>
                                                    <td>Subtype:</td>
                                                    <td>{this.state.account.subtype}</td>
                                                </tr>
                                                <tr>
                                                    <td>Created:</td>
                                                    <td>{this.getDateTime(this.state.account.created)}</td>
                                                </tr>
                                                <tr>
                                                    <td>Closed:</td>
                                                    <td>{this.getDateTime(this.state.account.closed)}</td>
                                                </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {this.state.account && (
                                <AccountActions onAccountUpdated={()=>this.refreshContent()} account={this.state.account}/>
                            )}
                        </div>

                        <div className="col-lg-6">
                            <div className="row">
                                <div className="col-lg-6">
                                    {this.state.account.userId &&
                                        <UserLinkPanel userId={this.state.account.userId} header="Account Owner" />
                                    }
                                </div>
                                { this.state.balance.balance &&
                                    <div className="col-lg-6">
                                        <div className="card-box">
                                            <span className="badge badge-success float-right">{this.state.balance.balance.currencyCode}</span>
                                            <h5>Balance</h5>
                                            <h4 className="no-margins">{amount+" "+this.state.balance.balance.currencyCode}</h4>
                                            <small className="text-muted">{this.state.account.attributes["ROLE"]}</small>

                                        </div>
                                    </div>
                                }

                            </div>
                            <div className="row">
                                <div className="col-lg-12">
                                    <AttributePanel header="Account Attributes" attributes={this.state.account.attributes}/>
                                </div>
                            </div>

                        </div>

                    </div>

                    <div className="row">
                        <div className="col-md-12">
                            <TransactionEntriesList accountId={(this.props.match.params as any).id} service={this.transactionEntriesService} />
                        </div>
                    </div>




            </div>
        );
    }

}
export default withRouter(AccountView);